import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TableRow, TableCell } from '@mui/material';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import ModalForUpdateVehicle from './ModalForUpdateVehicle';

const VehicleRow = ({
  vehicle,
  updateVehicle,
  deleteVehicle,
  dispatch,
  vehicleReducer,
  clearValidationErrors,
  brandReducer
}) => {
  const [show, setShow] = useState(false);

  const onDeleteClick = (id) => {
    const action = () => {
      dispatch(deleteVehicle(id));
    };
    confirmDialog('obrišete vozilo', action, ', obriši!');
  };

  const showModalUpdate = () => {
    setShow(true);
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleEdit = (vehicle) => {
    dispatch(updateVehicle(vehicle, handlePreviewClose));
  };

  let row = (
    <>
      <TableRow>
        <TableCell>{vehicle.vehicleName}</TableCell>
        <TableCell>{vehicle.brand?.brandName}</TableCell>
        <TableCell>{vehicle.vehicleModel?.modelName}</TableCell>
        <TableCell>{vehicle.licensePlateNumber}</TableCell>
        <TableCell>{vehicle.driver?.username}</TableCell>

        <TableCell className="text-center" id="centerRow">
          <Link to="#" onClick={() => showModalUpdate()}>
            <i className="fas fa-edit fa-2x i" />
          </Link>
        </TableCell>
        <TableCell
          className={`text-center ${vehicle.id === 2 && 'disable-events'}`}
        >
          <Link to="#" id="deleteVehicle" onClick={() => onDeleteClick(vehicle.id)}>
            <i
              className={`fas fa-trash-alt fa-2x ${vehicle.id === 2 && 'disable-color'
                }`}
            />
          </Link>
        </TableCell>
      </TableRow>
    </>
  );

  return (
    <>
      {row}

      {show && (
        <ModalForUpdateVehicle
          show={show}
          vehicle={vehicle}
          updateVehicle={handleEdit}
          handleClose={handlePreviewClose}
          vehicleReducer={vehicleReducer}
          brandReducer={brandReducer}
        />
      )}
    </>
  );
};

export default VehicleRow;
